import { Component, ChangeDetectionStrategy } from "@angular/core";
import { GridBaseComponent } from "../grid-base/grid-base.component";

@Component({
    selector: "rask-grid-link",
    templateUrl: "./grid-link.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["../grid-base/grid-base.component.scss"]
})

export class GridLinkComponent extends GridBaseComponent {
    click = (event: Event) => {
        event.preventDefault();
        this.onClick(this.row);
    };
}
